module.exports = __webpack_public_path__ + "img/mgh-kyobashi.a1a3a2dd.jpg";